const interiorIcon = "https://d1vqw4it8x9uac.cloudfront.net/admin/interior-design-bro-1-1790236892.png";
const architectureIcon = "https://d1vqw4it8x9uac.cloudfront.net/admin/house-restyling-bro-1-1790236892.png";

export const DUMMY_CATEGORIES = [
  {
    id: "interior_design",
    label: "Interior Design",
    icon: interiorIcon,
  },
  {
    id: "architecture",
    label: "Architecture",
    icon: architectureIcon,
  },
  {
    id: "furniture",
    label: "Furniture",
    icon: interiorIcon,
  },
  {
    id: "vastu",
    label: "Vastu",
    icon: architectureIcon,
  },
  {
    id: "automation",
    label: "Automation",
    icon: interiorIcon,
  },
  {
    id: "solar_panels",
    label: "Solar Panels",
    icon: architectureIcon,
  },
];

const BASE_QUESTIONS = [
  {
    id: "home_type",
    type: "select",
    label: "Home type",
    description: "Helps professionals understand the scope",
    required: true,
    options: [
      { label: "Space Planning", value: "space_planning" },
      { label: "Architecture", value: "architecture" },
      { label: "Interior Design", value: "interior_design" },
      { label: "Landscape Design", value: "landscape_design" },
      { label: "Furniture Design", value: "furniture_design" },
      { label: "Lighting Design", value: "lighting_design" },
      { label: "Material Selection", value: "material_selection" },
      { label: "Color Consultation", value: "color_consultation" },
      { label: "Project Management", value: "project_management" },
    ],
  },
  {
    id: "property_type",
    type: "dropdown",
    label: "City",
    pageTitle: "Where is your project located?",
    pageDescription: "We'll connect you with professionals around you",
    hideFieldLabel: true,
    required: true,
    placeholder: "Search your city",
    options: [
      { label: "Bangalore", value: "bangalore" },
      { label: "Hyderabad", value: "hyderabad" },
      { label: "Pune", value: "pune" },
      { label: "Delhi NCR", value: "delhi_ncr" },
    ],
  },
  {
    id: "site_status",
    type: "radio",
    label: "Project start timeline",
    pageTitle: "When would you like to get started?",
    pageDescription: "This helps professionals plan better for you",
    hideFieldLabel: true,
    required: true,
    options: [
      { label: "Start soon", subLabel: "2 - 4 weeks", value: "2_4_weeks" },
      { label: "Planning stage", subLabel: "1 - 3 months", value: "1_3_months" },
      { label: "Exploring options", subLabel: "3-6 months", value: "3_6_months" },
    ],
  },
  {
    id: "budget",
    type: "range",
    label: "Estimated budget",
    pageTitle: "What's your estimated budget?",
    pageDescription: "This helps match you with the right professionals",
    helperLabel: "Select a budget",
    hideFieldLabel: true,
    required: true,
    options: [
      { label: "₹ Under 3L", value: "under_3l" },
      { label: "₹ 3 - 5L", value: "3_5l" },
      { label: "₹ 5 - 8L", value: "5_8l" },
      { label: "₹ 8 - 12L", value: "8_12l" },
      { label: "₹ 12 - 20L", value: "12_20l" },
      { label: "₹ 20 - 35L", value: "20_35l" },
      { label: "₹ 35L+", value: "35l_plus" },
    ],
  },
  {
    id: "full_name",
    type: "text-input",
    label: "Full name",
    required: true,
    placeholder: "Enter your name",
  },
  {
    id: "project_details",
    type: "multiline",
    label: "Project details",
    pageTitle: "Add any details or preferences",
    pageDescription: "Tell professionals what you have in mind",
    hideFieldLabel: true,
    required: false,
    placeholder: 'Describe your requirement (optional) e.g. "2BHK renovation, budget 10L..."',
  },
];

const CATEGORY_QUESTIONS = {
  architecture: [
    {
      id: "floors",
      type: "dropdown",
      label: "Floors planned",
      required: true,
      placeholder: "Select floors",
      options: [
        { label: "1 floor", value: "1" },
        { label: "2 floors", value: "2" },
        { label: "3 floors", value: "3" },
        { label: "4+ floors", value: "4_plus" },
      ],
    },
  ],
  landscape: [
    {
      id: "landscape_area",
      type: "radio",
      label: "Landscape area",
      required: true,
      options: [
        { label: "Under 500 sq ft", value: "small" },
        { label: "500 - 1500 sq ft", value: "medium" },
        { label: "1500+ sq ft", value: "large" },
      ],
    },
  ],
};

export const getDummyQuestionsByCategory = (categoryId) => {
  const categorySpecific = CATEGORY_QUESTIONS[categoryId] || [];
  return [...BASE_QUESTIONS, ...categorySpecific];
};
